import script from "./Footer2.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer2.vue?vue&type=script&setup=true&lang=js"

import "./Footer2.vue?vue&type=style&index=0&id=501d0640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501d0640"]])

export default __exports__